import $ from "jquery"
import {Result} from "../types";

interface Props {
    result: KnockoutObservable<Result>
    query: KnockoutObservable<string>
    visible: KnockoutObservable<boolean>
}

export class SearchBarView {
    props: Props

    constructor(props: Props) {
        this.props = props

        props.visible.subscribe(visible => {
            visible && setTimeout(() => {
                const interval = setInterval(() => {
                    const el = $("[type=search]")[0]
                    if (el) {
                        el.focus()
                        clearInterval(interval)
                    }
                }, 10)
            }, 10)
        })

        $(document).on("keyup", e => {
            if (e.key === "Escape") {
                if (props.query()) {
                    props.query("")
                }
            }
        })
    }

    isViewAllResultsBtnVisible = () => {
        return this.props.result().totalItems > 0
    }

    viewAllUrl = () => {
        return this.props.result().urlAll
    }

}
